import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from 'assets/icons';
import { urls } from 'services/_url';
import styles from './password.module.css';

const PasswordResetSuccessful = () => {
  const history = useNavigate();

  return (
    <div className={styles.pageWrapper}>
      <a href={urls.landing} className={styles.homeBtn}>
        <Icon name="home" width={16} height={16} />
        Home
      </a>

      <div className={styles.formInner}>
        <div className={styles.successIcon}>
          <Icon name="check" width={32} height={32} />
        </div>
        <h1 className={styles.successHeading}>Password reset!</h1>
        <p className={styles.successBody}>
          Your password has been updated successfully. You can now log in with your new password.
        </p>
        <button className={styles.submitBtn} onClick={() => history('/login')}>
          Go to log in →
        </button>
      </div>
    </div>
  );
};

export default PasswordResetSuccessful;
